import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RruleComponent } from './rrule.component';
import { SharedModule } from 'app/shared/shared.module';



@NgModule({
  declarations: [
    RruleComponent
  ],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [
    RruleComponent
  ]
})
export class RruleModule { }
